import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsDetailCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-family/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsDetailCivilStatusMotherPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsDetailCivilStatusShared isMother scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

ResearchFamilyNotificationsDetailCivilStatusMotherPage.displayName =
  'Research Family Notifications CivilStatusMotherPage component';

export default ResearchFamilyNotificationsDetailCivilStatusMotherPage;
